import { Link } from 'react-router-dom';
import { getPopularComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function FeaturedSection() {
  const popularComics = getPopularComics().slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              高分推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              口碑炸裂，千万读者倾情推荐
            </p>
          </div>
          <Link
            to="/category/hanman"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {popularComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/hanman"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}